import { render, staticRenderFns } from "./ShopifyShippingDetails.vue?vue&type=template&id=55085038&scoped=true&"
import script from "./ShopifyShippingDetails.vue?vue&type=script&lang=js&"
export * from "./ShopifyShippingDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShopifyShippingDetails.vue?vue&type=style&index=0&id=55085038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55085038",
  null
  
)

component.options.__file = "ShopifyShippingDetails.vue"
export default component.exports